<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <v-tour name="blogisticTour" :steps="steps" :callbacks="callbacksTour"></v-tour>
                            <h4 class="card-title">Monitor CTE</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreate()" v-b-tooltip title="Cadastrar"><i class="ft-plus" v-if="getPermission('monitorcte.store')"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <vuetable ref="vuetable"
                                            api-url="/api/monitorcte"
                                            :fields="fields"
                                            :css="css"
                                            :append-params="moreParams"
                                            track-by="xmlctelot_id"
                                            pagination-path=""
                                            @vuetable:load-error="onError"
                                            @vuetable:pagination-data="onPaginationData"
                                            @vuetable:cell-clicked="onDetail"
                                            @vuetable:loaded="onLoaded"
                                            detail-row-component="monitorcte-detalhes"
                                          >
                                          <template slot="status" slot-scope="props">
                                              <span class="badge badge-success" v-if="props.rowData.status_proc.valor==1">{{ props.rowData.status_proc.descr }}</span>
                                              <span class="badge badge-danger" v-if="props.rowData.status_proc.valor==2">{{ props.rowData.status_proc.descr }}</span>
                                              <span class="badge badge-warning" v-if="props.rowData.status_proc.valor==3">{{ props.rowData.status_proc.descr }}</span>

                                          </template>

                                          <template slot="actions" slot-scope="props">
                                            <div class="custom-actions">
                                                <span v-if="getPermission('monitorcte.status')">
                                                    <a @click="onEvento(props.rowData, 1,props.rowData.status_proc.valor)" v-b-tooltip title="Reenviar Lote"><i class="fa fa-repeat "></i></a>
                                                    <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                                </span>
                                              </button>
                                            </div>
                                          </template>
                                      </vuetable>
                                  </div>
                                <div>
                                    <div class='col-md-12'>
                                        <div class="pull-left pagination-detail">
                                            <vuetable-pagination-info ref="paginationInfo"
                                                                      :css="css.pagination"
                                                                      info-class="pull-left"
                                            ></vuetable-pagination-info>
                                        </div>
                                        <div class="pull-right m-a-0">
                                            <vuetable-pagination ref="pagination"
                                                                 :css="css.pagination"
                                                                 @vuetable-pagination:change-page="onChangePage"
                                            ></vuetable-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
              <!-- Modal Component -->
              <b-modal id="modal_form_ver_xml"
                       ref="modal_form_ver_xml"
                       :title="modal_titulo"
                       :ok-title="modal_botao"
                       close-title="Fechar"
                       cancel-title="Cancelar"
                       :ok-disabled=form.errors.any()
                       v-model="showModalVerXml"
                       @ok="handleOk">

                       <b-form-textarea v-model="xml"
                                        placeholder="XML"
                                        :rows="12"
                                        :max-rows="12">
                       </b-form-textarea>

               <b-form-feedback v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>
                    <div slot="modal-footer" class="w-100">
                           <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                           <div class="float-right">
                               <b-btn @click="showModalVerXml=false" variant="secondary">
                                 Fechar
                               </b-btn>
                           </div>
                    </div>
                </b-modal>
              <!-- Modal Component -->
              <b-modal id="modal_form"
                       ref="modal_form"
                       :title="modal_titulo"
                       :ok-title="modal_botao"
                       close-title="Fechar"
                       cancel-title="Cancelar"
                       :ok-disabled=form.errors.any()
                       v-model="showModal"
                       @ok="handleOk">

             <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
               <div v-if="this.modal_acao == 'u'">
                 <label>Código</label>
                 <b-form-input type="text"
                               placeholder="Código"
                               v-model="form.cd"
                               name="cd"
                               >
                 </b-form-input>
                 <b-form-feedback v-text="form.errors.get('cd')" v-if="form.errors.has('cd')"></b-form-feedback>
               </div>

                 <label>Descrição</label>
                 <b-form-input type="text"
                               placeholder="Descrição"
                               v-model="form.descr"
                               name="descr"
                               >
                 </b-form-input>
                 <b-form-feedback v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>

                 <label>Status</label>
                 <multiselect v-model="form.status_proc"
                 :options="optionsLivStatus"
                 track-by="value"
                 label="label"
                 :hide-selected="true"
                 placeholder="Selecione"
                 tag-placeholder="Selecionar"
                 select-label="Selecionar"
                 selected-label="Selecionado"
                 deselect-label="Remover"
                 ></multiselect>
                 <b-form-feedback v-text="form.errors.get('status_proc.value')" v-if="form.errors.has('status_proc.value')"></b-form-feedback>

             </form>
                    <div slot="modal-footer" class="w-100">
                           <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                           <div class="float-right">
                               <b-btn @click="showModal=false" variant="secondary">
                                 Fechar
                               </b-btn>
                               <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                                 Enviar
                               </b-btn>
                           </div>
                    </div>
                </b-modal>
    </div>
</div>
</template>
<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import MonitorCteFilterBar from './MonitorCteFilterBar'
import moment from 'moment'
import MonitorCteDetalhes from './MonitorCteDetalhes'

Vue.component('monitorcte-detalhes', MonitorCteDetalhes);

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        'vuetable-filterbar': MonitorCteFilterBar
    },
    data () {
        return {
          dataExport: [],
          modal_titulo: '',
          modal_botao: '',
          modal_acao: '',
          xml: '',
          loading: false,
          isDisabled: false,
          loadingData: true,
          showModal: false,
          isFullscreen: false,
          showModalVerXml: false,
          optionsLivStatus: [],
          form: new Form({ tp_evento: '',
                           xmlctelot_id: '',
                           status_proc: []
                       }),
         helpForm: new Form({statusRecord: [], params: []}),
        fields: [
          {
              name: '__checkbox',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          },
          {
            name: 'num_lote',
            title: 'N° Lote',
            sortField: 'num_lote'
          },
          {
            name: 'num_recibo',
            title: 'N° Recibo',
            sortField: 'num_recibo'
          },
          {
            name: 'dt_hr_receb_str',
            title: 'Hora Receb.',
            sortField: 'dt_hr_receb_str'
          },
          {
            name: 'dt_hr_receb',
            title: 'Hora Receb.',
            callback: 'formatDate|DD/MM/YYYY HH:mm'
          },
          {
            name: 'tempo_medio_resposta',
            title: 'Tempo médio resposta',
            sortField: 'tempo_medio_resposta'
          },
          {
            name: 'descr_status',
            title: 'Status',
            sortField: 'descr_status'
          },
          {
            name: '__slot:status',
            title: 'Status',
            sortField: 'status'
          },
          {
              name: '__slot:actions',   // <----
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          }
      ],
      css: {
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
       }
    },
    mounted() {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset());
        this.getLivStatus();
      },
      created() {
          let self = this;
          Event.$on('verXml', function (xml) {console.log(xml)
              self.onVerXml(xml);
          });
          Event.$on('reloadVuetable', function (data) {
              self.onReloadVuetable();
          });

      },
    methods: {
        onPaginationData (paginationData) {
          this.$refs.pagination.setPaginationData(paginationData)
          this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
          this.$refs.vuetable.changePage(page)
        },
        onReloadVuetable() {
            this.$refs.vuetable.reload();
        },
        onFilterSet (data_filter) {
            this.loadingData = true;
            this.moreParams = {
                'num_fiscal': data_filter.num_fiscal,
                'chave': data_filter.chave,
                'status_proc': data_filter.status_proc.value
            }
            Vue.nextTick( () => {this.$refs.vuetable.reload(); })
        },
        onFilterReset () {
            this.loadingData = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterShowHide() {
            if(this.vuetableFilterRow)
            {
                this.$store.commit('setVuetableFilterRow', false);
            }
            else
            {
                this.$store.commit('setVuetableFilterRow', true);
            }
        },
        formatDate (value, fmt = 'D MMM YYYY HH:mm') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
        },
        onLoaded: function () {
            this.dataExport = this.$refs.vuetable.tableData;
            this.loadingData = false;
            this.$store.commit('setVuetableFilterButton', false);
        },
        onDetail (data, field, event) {
            this.$refs.vuetable.toggleDetailRow(data.xmlctelot_id);
        },
        handleOk(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStore();
            }
            else if (this.modal_acao=="v")
            {
                this.onVerXml();
            }
            else
            {
                this.onUpdate(this.form.xmlctelot_id);
            }
        },
        onCreate ()
        {
          this.isDisabled = false;
          this.loading = false;
          this.modal_titulo = "Cadastrar";
          this.modal_botao = "Cadastrar";
          this.modal_acao = "i";
          this.form.reset();
          this.$refs.modal_form.show();
        },
        onEdit (data, index)
        {
          this.isDisabled = false;
          this.loading = false;
          this.modal_titulo = "Alterar";
          this.modal_botao = "Alterar";
          this.modal_acao = "u";
          this.form.reset();
          this.form.cd = data.cd;
          this.form.descr = data.descr;
          this.form.status_proc = { label: data.status_proc.descr, value: data.status_proc.valor };
          this.form.xmlctelot_id = data.xmlctelot_id;
          this.$refs.modal_form.show();
        },
        onStore()
        {
            this.loading = true;
            this.isDisabled = true;
            this.form.post('/api/monitorcte/store').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onVerXml(xml)
        {
          this.isDisabled = false;
          this.loading = false;
          this.modal_titulo = "XML";
          this.modal_botao = "XML";
          this.modal_acao = "v";
          this.form.reset();
          this.xml = xml;
          this.$refs.modal_form_ver_xml.show();
        },
        onUpdate(id)
        {
            this.loading = true;
            this.isDisabled = true;
            this.form.post('/api/monitorcte/update/'+id).then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onEvento (data, tp_evento, status_proc) {

            let form = this.form;

            let confirmFn = function(vm) {
                form.xmlctelot_id = data.xmlctelot_id;
                form.tp_evento = tp_evento;
                form.status_proc = status_proc;

                form.post('/api/monitorcte/evento').then(response =>
                {
                    new ReturnApi(response, vm)
                    vm.$refs.vuetable.reload();
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, vm)
                });
            }

            if(tp_evento==1) {
                var vv_descr_evento = "Reenviar";
            }

            let obj = {
                title: 'Você deseja '+vv_descr_evento+' todo o lote?',
                message: '',
                customConfirmBtnText: 'Sim',
                customCloseBtnText: 'Não',
                type: 'info',
                useConfirmBtn: true,
                onConfirm: confirmFn(this)
            }

            this.$Simplert.open(obj);

            /*
            let dados = data;
            let form = this.form;


            let swal = this.$swal;
            let ref = this.$refs;
            this.$swal({
                  title: 'Você deseja encerrar o MDFE ?',
                  text: "Esta ação é irreversível",
                  type: 'question',
                  showCancelButton: true,
                  confirmButtonText: 'Sim, encerrar!',
                  cancelButtonText: 'Não',
                }).then(function () {
                    $(this).loading = true;
                    $(this).isDisabled = true;

                }, function (dismiss) {
                        // Cancel
                });
                */
        },
        getLivStatus()
        {
            this.helpForm.params = { tabela: 'xml_cte_lote',
                                    coluna: 'status_proc' };

            this.helpForm.get('/api/listitemvalor/jsonlist').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.items.forEach((obj)=>
                {
                    this.optionsLivStatus.push({ label: obj.descr, value: obj.valor })
                })
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onActivateDesactivate(action, data, tipo)
        {
            // Tipo = true = Checkbox
            if(tipo)
            {
                this.helpForm.statusRecord = [];
                this.helpForm.statusRecord.push({ id: data.xmlctelot_id, status: action });
            }
            else
            {
                this.helpForm.statusRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.statusRecord.push({ id: obj, status: action })
                });
            }

            this.helpForm.post('/api/monitorcte/status').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });

        },
        onError(response) {
            new ReturnApi(response.response, this, true, true, false);
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },
    },
    computed: {
        vuetableFilterRow: {
          get () {
            return this.$store.state.vuetable.filterRow;
          },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
  }
  </script>
